module.exports = __webpack_public_path__ + "static/html_2-3ba1c91185b1062713c7ac28fb59a4ae.jpg";